(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfDatepicker', function() {
    return {
      link: function(scope, ele, attrs) {
        return ele.datepicker({
          beforeShow: (function(_this) {
            return function(input, instance) {
              return $('#bs2-container').append($('#ui-datepicker-div'));
            };
          })(this)
        });
      }
    };
  });

}).call(this);
